import { render } from "./lux_page.vue?vue&type=template&id=5892a2dc"
import script from "./lux_page.vue?vue&type=script&lang=js"
export * from "./lux_page.vue?vue&type=script&lang=js"

import "./lux_page.vue?vue&type=style&index=0&id=5892a2dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__